import { useEffect } from 'react';
import { contract } from '@aviv_price-pages/brand';
import { useLocation, useNavigate } from '@aviv-unified-frontend/runtime/router';
import { appendEphemeralParam } from '@/helpers/ephemeral/ephemeral';
import { normalizePath } from '@/helpers/redirect/redirect';
export const useClientSideRedirect = () => {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const matchedRedirect = contract.redirects?.find((redirect) => pathname === `${contract.basePath}${redirect.source}`);
        if (matchedRedirect) {
            const destination = `${contract.basePath}${matchedRedirect.destination}`;
            const normalized = normalizePath(destination);
            const fullCanonicalUrl = appendEphemeralParam(normalized + search);
            navigate(fullCanonicalUrl, { replace: true });
        }
    }, [pathname, search, navigate]);
};
